export namespace nsObjectRouteLink {

    const _LinkableRouteIds = [
        'apiuserdetails',
        'userdetails',
        'groupdetails',
        'departmentdetails',
        'manualapiuserdetails',
        'manualuserdetails',
        'manualgroupdetails',
        'manualdepartmentdetails',
    ] as const

    export type TLinkableRouteId = typeof _LinkableRouteIds[number]

    type TLinkableRouteIds = {
        [key in TLinkableRouteId]: TLinkableRouteId
    }

    export const LinkableRouteIds: TLinkableRouteIds = {
        'apiuserdetails': 'manualapiuserdetails',
        'userdetails': 'manualuserdetails',
        'groupdetails': 'manualgroupdetails',
        'departmentdetails': 'manualdepartmentdetails',
        'manualapiuserdetails': 'apiuserdetails',
        'manualuserdetails': 'userdetails',
        'manualgroupdetails': 'groupdetails',
        'manualdepartmentdetails': 'departmentdetails',
    }
}